import {defineStore} from 'pinia'
import {useMenuNavApi} from '@/api/sys/menu'
import {constantMenu, commonMenu, generateRoutes} from '@/router'
import {RouteRecordRaw} from 'vue-router'
import {useChronicAdminAccessApi} from '@/api/doctor/chronic'

const restrictedAdminChronicUrls = [
    'doctor/chronic/packOrder/',
    'doctor/chronic/pack/',
    'doctor/chronic/package/',
    'doctor/chronic/packageClassify/'
]

// 菜单隐藏只是 UI 体验，所有读写接口必须单独在后端做机构范围校验。
const pruneAdminChronicMenus = (items: any[]): any[] =>
    items.flatMap(item => {
        const url = String(item.url || '').replace(/^[/]+/, '')
        if (restrictedAdminChronicUrls.some(prefix => url.startsWith(prefix))) return []
        // 后端可能给叶子菜单也带 children: []；只有原本存在子菜单的父节点
        // 才应该在权限过滤后因孩子全空而被移除。
        if (!Array.isArray(item.children) || item.children.length === 0) return [item]
        const children = pruneAdminChronicMenus(item.children)
        return children.length > 0 ? [{...item, children}] : []
    })

export const routerStore = defineStore('routerStore', {
    state: () => ({
        menuRoutes: [] as RouteRecordRaw[],
        routes: [] as RouteRecordRaw[]
    }),
    actions: {
        async getMenuRoutes(id?: number) {
            const {data} = await useMenuNavApi()
            // 共用的历史菜单权限不代表机构管理权，失败时默认不显示管理菜单。
            let adminAllowed = false
            try {
                const access = await useChronicAdminAccessApi()
                adminAllowed = access.code === 0 && access.data === true
            } catch {
                adminAllowed = false
            }
            const scopedMenus = adminAllowed ? data : pruneAdminChronicMenus(data || [])
            const routes = generateRoutes(scopedMenus)

            // 所有已登录用户追加公共菜单
            const commonRoutes = generateRoutes(commonMenu)
            this.menuRoutes.push(...commonRoutes)

            // 仅 super admin (id===1) 追加原 constantMenu
            if (id === 1) {
                const constantRoutes = generateRoutes(constantMenu)
                this.menuRoutes.push(...constantRoutes)
            }

            this.menuRoutes.push(...routes)
            return this.menuRoutes
        },
        setRoutes(routers: RouteRecordRaw[]) {
            this.routes = routers
        }
    },
})
